import { AUTH } from 'store/store.constants';

const selectAuthSlice = (state) => state[AUTH];
export const selectIsAuthenticated = (state) => selectAuthSlice(state).isAuthenticated;
export const selectToken = (state) => selectAuthSlice(state).token;
export const selectAccessToken = (state) => selectToken(state)?.access;
export const selectTokenExpiration = (state) => selectToken(state)?.access_exp;
export const selectMyId = (state) => selectAuthSlice(state).myId;
